import classNames from 'classnames';

import styles from './Title.module.css';

import {
  getFontClass,
  getFontWeightClass,
  getTitleSizeClass,
  getColorClass,
  getAttentionColorName,
  TitleSizeProps,
  FontProps,
  ColorProps,
  WeightProps,
  TextTrackingProps,
  getTrackingClass,
  TextLeadingProps,
  getLeadingClass
} from '../../../constants/typography';

interface Props {
  as?: TitleSizeProps;
  font?: FontProps;
  size?: 1 | 2 | 3 | 4 | 5 | 6;
  weight?: WeightProps;
  italic?: boolean;
  color?: ColorProps | 'inherit';
  tracking?: TextTrackingProps;
  leading?: TextLeadingProps | null;
  className?: string;
  onClick?: () => null;
  children?:
    | string
    | string[]
    | JSX.Element
    | JSX.Element[];
}

function Title({
  as: Tag = 'h2',
  font = 'circular',
  size,
  weight = 700,
  italic = false,
  color = 'blue',
  tracking = 'normal',
  leading = null,
  className,
  children,
  onClick
}: Props) {
  return (
    <Tag
      className={classNames([
        styles.Title,
        styles[`Title-color`],
        className,
        getFontClass(font),
        size
          ? getTitleSizeClass(`h${size}`)
          : getTitleSizeClass(Tag),
        getFontWeightClass(weight),
        { italic },
        color !== 'inherit' && getColorClass(color),
        getTrackingClass(tracking),
        leading && getLeadingClass(leading)
      ])}
      style={Object.assign(
        {
          '--outline-color': `var(--color-${color})`
        } as React.CSSProperties,
        {
          '--attention-color': `var(--color-${getAttentionColorName(
            color
          )})`
        } as React.CSSProperties
      )}
      onClick={onClick}
    >
      {children}
    </Tag>
  );
}
export default Title;
